import React, {useState} from 'react';
import {TouchableOpacity} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Box from '@/Atoms/Box';
import Spacer from '@/Atoms/Spacer';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import type {CaissaReaction} from '@/Hooks/CaissaChatbot';

// For now we surface only the negative "incorrect answer" signal (a thumbs-down).
// It maps to reaction code 4 (thumbs_down = disliked) so nothing changes on the
// backend/DB; the other codes (1 thumbs_up, 2 heart, 3 confused) are not shown.
const DISLIKE_REACTION: CaissaReaction = 4;
const HOVER_TEXT = 'Report for an incorrect answer';
const HOVER_TEXT_ACTIVE = 'Click to undo';

type AnswerReactionsProps = {
  selected?: CaissaReaction | null;
  onSelect: (reaction: CaissaReaction | null) => void;
};

function AnswerReactions({selected, onSelect}: AnswerReactionsProps) {
  const isActive = selected === DISLIKE_REACTION;
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      style={{position: 'relative'}}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      {hovered ? (
        <Box
          style={{
            position: 'absolute',
            bottom: '120%',
            right: 0,
            backgroundColor: CCColors.TextColor.Dark,
            paddingVertical: 4,
            paddingHorizontal: 8,
            borderRadius: 6,
            zIndex: 5,
          }}>
          <CCText
            fontSize={FontSizes[11]}
            color={CCColors.White}
            style={{whiteSpace: 'nowrap'}}>
            {isActive ? HOVER_TEXT_ACTIVE : HOVER_TEXT}
          </CCText>
        </Box>
      ) : null}
      <TouchableOpacity
        // Toggle: tap to mark "incorrect", tap again to undo.
        onPress={() => onSelect(isActive ? null : DISLIKE_REACTION)}
        activeOpacity={0.6}
        accessibilityLabel={isActive ? HOVER_TEXT_ACTIVE : HOVER_TEXT}
        style={{flexDirection: 'row', alignItems: 'center'}}>
        <MaterialCommunityIcons
          name={isActive ? 'thumb-down' : 'thumb-down-outline'}
          size={16}
          color={isActive ? CCColors.Red : CCColors.Grey.Grey}
        />
        <Spacer spacing={4} horizontal />
        <CCText
          fontSize={FontSizes[11]}
          color={isActive ? CCColors.Red : CCColors.Grey.Grey}>
          Incorrect answer
        </CCText>
      </TouchableOpacity>
    </Box>
  );
}

export default AnswerReactions;
